import React from 'react';

import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/all';

import flatHome from '../../assets/images/flat_home.png';

import './styles.css';

export default function Home() {
    return(
        <div className="home-container">
            <div className="home-content">
                <p className="home-text">
                    Olá,<br />
                    eu sou <span className="span-green-text">André</span>,<br />
                    Desenvolvedor<br />
                    <span className="span-pink-text">Backend</span><br />
                    e <span className="span-blue-text">Frontend</span>.
                </p>
                <h1 className="fullstack-title">FULLSTACK</h1>
                <a 
                    className="home-btn-git"
                    href="https://github.com/alaodev"
                    target="_blank"
                >
                    Meu GitHub
                </a>
                <img 
                    className="flat-home" 
                    src={ flatHome } 
                    alt="Ilustração" 
                />
                <div className="social-icons">
                    <a href="https://www.linkedin.com/in/alaodev">
                        <FaLinkedin />
                    </a>
                    <a href="https://web.facebook.com/profile.php?id=100026429555285">
                        <FaFacebook />
                    </a>
                    <a href="https://www.instagram.com/default_follower/">
                        <FaInstagram />
                    </a>
                </div>
            </div>
        </div>
    );
}